import { render, staticRenderFns } from "./EventPopupCategoryHeader.vue?vue&type=template&id=3c8f092e&scoped=true&"
import script from "./EventPopupCategoryHeader.vue?vue&type=script&lang=ts&"
export * from "./EventPopupCategoryHeader.vue?vue&type=script&lang=ts&"
import style0 from "./EventPopupCategoryHeader.vue?vue&type=style&index=0&id=3c8f092e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8f092e",
  null
  
)

export default component.exports